import { render, staticRenderFns } from "./TournamentOwnership.vue?vue&type=template&id=21749956&scoped=true"
import script from "./TournamentOwnership.vue?vue&type=script&lang=js"
export * from "./TournamentOwnership.vue?vue&type=script&lang=js"
import style0 from "./TournamentOwnership.vue?vue&type=style&index=0&id=21749956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21749956",
  null
  
)

export default component.exports